module.exports = __webpack_public_path__ + "img/plane_track_4.27874c56.svg";